"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlassesIcon = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const GlassesIcon = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "111.109",
  height: "57.377",
  viewBox: "0 0 111.109 57.377",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "Group_26914",
    "data-name": "Group 26914",
    transform: "translate(-697.5 -690.37)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Path_18415",
      "data-name": "Path 18415",
      d: "M371.016,442.1c-5.788.12-9.815,4.6-10.251,10.223-.191,2.461,3.639,2.471,3.829.028a20.111,20.111,0,0,1,.882-2.978,5.92,5.92,0,0,1,5.513-3.444C373.451,445.875,373.481,442.046,371.016,442.1Z",
      transform: "translate(403.539 261.716)",
      fill: "#333",
      stroke: "#333",
      strokeWidth: "1"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Path_18416",
      "data-name": "Path 18416",
      d: "M80.557,442.1c-5.788.12-9.815,4.6-10.251,10.223-.191,2.461,3.639,2.471,3.828.028a20.155,20.155,0,0,1,.882-2.978,5.92,5.92,0,0,1,5.513-3.444C82.992,445.875,83.023,442.046,80.557,442.1Z",
      transform: "translate(640.62 261.716)",
      fill: "#333",
      stroke: "#333",
      strokeWidth: "1"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Path_18417",
      "data-name": "Path 18417",
      d: "M236.1,647.5a9.041,9.041,0,0,0-12.12.015c-1.8,1.676-4.5-1.035-2.692-2.721,5.144-4.8,12.276-4.45,17.534.014C240.7,646.4,237.971,649.085,236.1,647.5Z",
      transform: "translate(517.866 99.102)",
      fill: "#333",
      stroke: "#333",
      strokeWidth: "1"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Path_18418",
      "data-name": "Path 18418",
      d: "M109.434,424.492l-14.7-14.7a23.154,23.154,0,1,0-40.216-9.632c-.026.02-.053.033-.079.055a6.829,6.829,0,0,1-8.8.208,23.207,23.207,0,1,0-1.3,3.776,10.424,10.424,0,0,0,11.411-.264A23.164,23.164,0,0,0,92.028,412.5l14.713,14.714C108.483,428.955,111.181,426.239,109.434,424.492ZM23.163,413.415a18.57,18.57,0,1,1,18.57-18.57A18.591,18.591,0,0,1,23.163,413.415Zm40.768-5.457A18.57,18.57,0,1,1,77.063,413.4,18.449,18.449,0,0,1,63.931,407.958Z",
      transform: "translate(698 319.206)",
      fill: "#333",
      stroke: "#333",
      strokeWidth: "1"
    })]
  })
});
exports.GlassesIcon = GlassesIcon;
